export type TickerType = 'stock' | 'index' | 'crypto' | 'futures';

export function getTickerType(ticker: string): TickerType {
  if (ticker.startsWith('^')) return 'index';
  if (ticker.startsWith('$')) return 'crypto';   // crypto AND forex ($BTC, $EURUSD)
  if (ticker.endsWith('=F')) return 'futures';   // Yahoo-style futures suffix (ES=F)
  return 'stock';
}

export function confirmTicker(ticker: string): ticker is Ticker {
  // Regular expression to check if the ticker starts with an uppercase letter (A-Z) and
  // contains only uppercase letters, numbers and allowed special characters ($, =, ^).
  // `*` (not `+`) after the first character: single-letter tickers (A, M, F, ...)
  // are valid — `+` required a second character and silently rejected them.
  const tickerRegex = /^[A-Z$^][A-Z0-9$=^.]*$/;

  // Check if the ticker matches the pattern and has a valid length (1 to 6 characters as a common limit)
  // Allow longer tickers if they start with '^' (e.g., for indices) or '$' (e.g., for crypto/currencies)
  const isValidLength = (ticker.length >= 1 && ticker.length <= 5)
    || (ticker.length <= 8 && (ticker.startsWith('^') || ticker.startsWith('$')));

  return tickerRegex.test(ticker) && isValidLength;
}
